const INPUT_LABEL_LIST_DATA = [
  "일자",
  "시간",
  "지종",
  "기준 평량",
  "작업 호기",
  "SPEED",
  "실평량",
  "수분",
  "두께", 
  "MD 압강",
  "CD 압강",
  "MD/CD",
  "파강",
  "색상 L",
  "색상 A",
  "색상 B",
  "Cobb size",
  "Cobb 온도",
  "Cobb 습도",
  "여분 1",
  "여분 2",
  "여분 3",
  "여분 4",
  "여분 5",
  "여분 6",
  "여분 7",
  "여분 8",
];
export default INPUT_LABEL_LIST_DATA;